module.exports = __webpack_public_path__ + "img/596.22e00a91.jpg";